import type { WidgetJobsKind, WidgetJobsState } from '@recruitee/dashboard-types';
import type { PickActions } from '@recruitee/ngrx';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';

const {
  actions,
  reducer: JobsWidgetReducer,
  selectors: JobsWidgetSelectors,
  namespace: JobsWidgetNamespace,
} = createEntityCollectionStore<WidgetJobsState>()('JobsWidget', {
  customActions: adapter => {
    const actions = getEntityCollectionActions(adapter, ({ id }) => id);

    return {
      fetchOne: (state, payload: { id: WidgetJobsKind; departmentIds: number[] }) =>
        actions.fetchOne(state, payload),
    };
  },
});

const JobsWidgetActions: PickActions<typeof actions, 'fetchOne'> = actions;

export { JobsWidgetActions, JobsWidgetReducer, JobsWidgetSelectors, JobsWidgetNamespace };
